'use client';

import { Check } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';
import { Checkbox as CheckboxPrimitive } from './shadcn/checkbox';

/** Keeps checkbox controls and non-interactive indicators in one list media slot. */
export function CheckboxSlot({ children }: { children: ReactNode }) {
  return <span data-slot="checkbox-slot" className="inline-flex size-5 shrink-0 items-center justify-center pointer-coarse:min-h-[var(--touch-target)]">{children}</span>;
}

/** A presentational checkbox indicator. The clickable parent continues to own selection, so the Radix
 * root renders through its child and stays out of the parent's keyboard and pointer interaction. */
export function Checkbox({ checked, className = '' }: { checked: boolean; className?: string }) {
  return (
    <CheckboxPrimitive checked={checked} asChild className={cn('pointer-events-none', className)}>
      <span aria-hidden tabIndex={-1}>
        <Check
          size={11}
          strokeWidth={3}
          className={cn(
            'transition-transform duration-[var(--motion-fast)] ease-[var(--ease-spring)]',
            checked ? 'scale-100 opacity-100' : 'scale-50 opacity-0',
          )}
        />
      </span>
    </CheckboxPrimitive>
  );
}
